import React from 'react'

function Header({ isOfferPage }) {
    return (
        <div className="flex justify-center w-full max-w-[400px] items-center px-4 py-4 ">
          <img
            src={isOfferPage ? "/assets/img/newLogo.png" : "/assets/img/Footer logo.png"}
            alt="digitmoney logo"
            className="h-[24px] w-auto]"
          />
        </div>
    )
}

export default Header